import BaseModel from '../core/BaseModel'
export default class RecordDetailRealModel extends BaseModel {
    constructor() {
        super({ 
                name: "record_detail_real",
                tableName: 'record_detail', 
                label: "Danh sách nhập/xuất",
            },  
            {
                stt: { 
                    name: "stt",
                    label: "STT",
                    width : 5,
                    class: 'center',
                    computed: (data, index) => {
                        data.stt = index + 1;
                    }
                },
                id: { 
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                type : {
                    name: 'type',
                    type: "Selection",
                    label: 'Loại',
                    options: [
                        {value : 1 , label: "Nhập"},
                        {value : 2 , label : "Xuất"},
                        {value : 3 , label : "Chuyển hộp"},
                        {value : 4 , label : "Xuất chết"},
                        {value : 5 , label : "Xuất chết do vận chuyển"},
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                record_id:{
                    name: 'record_id', 
                    type: "Uuid", 
                    label: 'ID phiếu nhập',
                    display: false
                },
                number: {
                    name: 'number', 
                    type: "Number", 
                    label: 'Số lượng',
                    display: false,
                },
                active: {
                    name: 'active', 
                    type: "Selection", 
                    label: 'Trạng thái',
                    options: [
                        {value : 1 , label: "Hoạt động"},
                        {value : 0 , label : "Ngừng hoạt động"},
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                import_id: {
                    name: 'import_id', 
                    type: "Uuid", 
                    label: 'ID phiếu nhập',
                    display: false
                },
                import_dead:{
                    name: 'import_dead', 
                    type: "Number", 
                    label: 'Số lượng chết',
                    display: false
                },
                import_dead_weight:{
                    name: 'import_dead_weight', 
                    type: "Number", 
                    label: 'Trọng lượng chết',
                    display: false
                },
                userCreateBy: {
                    refs: "userCreateBy {id fullname}",
                    display: false
                },
                obj_box: {
                    refs: "obj_box {id code unit {id name code}}",
                    label: 'Khu vực nhập',
                    display: false
                },
                record: {
                    refs: "record {id code}",
                    label: 'Mã phiếu nhập',
                    display: false
                },
            },
        )
    }

}